type EnvType = {
    ENVIRONMENT: 'local' | 'development' | 'test' | 'preprod' | 'production';
    TENANT_ID: string;
    CLIENT_ID: string;
    MIDDLEWARE_API_SCOPES: string[];
    MIDDLEWARE_API_BASE_URL: string;
    REDIRECT_URI: string;
    APP_INSIGHTS_CONNECTION_STRING: string;
    GOOGLE_API_KEY: string;
    GOOGLE_CLIENT_ID: string;
    STORAGE_HELPER_UTILITY_KEY: string;
};

declare global {
    interface Window {
        appConfig: EnvType;
        google: any;
        gapi: any;
    }
}

export const appConfig: EnvType = {
    REDIRECT_URI: `${location.origin}`, //The URI to redirect to after authentication.
    ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT, // The current environment (e.g., development, production).
    TENANT_ID: import.meta.env.VITE_TENANT_ID, // The Entra tenant ID for authentication (same for all environments).
    CLIENT_ID: import.meta.env.VITE_CLIENT_ID, // The client ID of SyGPT front-end for authentication.
    // Use relative path in dev mode to leverage Vite proxy, otherwise use the full URL
    MIDDLEWARE_API_BASE_URL: import.meta.env.DEV ? '' : import.meta.env.VITE_MIDDLEWARE_API_BASE_URL, // The base URL for the SyGPT back-end API.
    MIDDLEWARE_API_SCOPES: JSON.parse(import.meta.env.VITE_MIDDLEWARE_API_SCOPES), // The Entra ID scopes required for authenticating the back-end APIs.
    APP_INSIGHTS_CONNECTION_STRING: import.meta.env.VITE_APP_INSIGHTS_CONNECTION_STRING, //The connection string for Application Insights.
    GOOGLE_API_KEY: import.meta.env.VITE_GOOGLE_API_KEY, // The API key for Google services.
    GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID, // The client ID for Google services.
    STORAGE_HELPER_UTILITY_KEY: import.meta.env.VITE_STORAGE_HELPER_UTILITY_KEY, // The key for the storage helper utility, used to encrypt and decrypt the token on the local storage
};
